
import PlusIcon from '../assets/icons/PlusIcon';
import React, { forwardRef } from 'react';

const Button = forwardRef(({ children, onClick, className = '', style }, ref) => {
  return (
    <button
      ref={ref}
      className={`btn btn-nav btn-flex${className ? ' ' + className : ''}`}
      type="submit"
      onClick={onClick}
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ...style }}
    >
      <PlusIcon style={{ marginRight: '10px' }} />
      <span style={{ textTransform: 'uppercase' }}>{children}</span>
    </button>
  );
});

export default Button;
